import React, { useState, useEffect } from "react";
import { Nav, Navbar, NavDropdown, Form, FormControl, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaTachometerAlt,
  FaTags,
  FaBox,
  FaBlog,
  FaBullhorn,
  FaClipboardList,
  FaReceipt,
  FaBars,
  FaBell
} from "react-icons/fa";

/* Pages */
import DashboardPage from "./DashboardPage";
import Productdescription from "../MarketingDashboard/Productdescription";
import BannersPage from "./BannersPage";
import BlogsPage from "./BlogPage";
import CustomersPage from "./CustomerPage";
import CategoriesPage from "./CategoriesPage";
import RequestsPage from "./RequestPage";
import ProductStocks from "./ProductStocks";
import SalesDashboard from "./SalesDashboard";
import ProfileEditPage from "./ProfileEditPage";

/* THEME */
const theme = {
  sidebarBg: "#0f172a",
  sidebarActive: "#2563eb",
  sidebarHover: "#1e293b",
  textPrimary: "#e2e8f0",
  textMuted: "#94a3b8",
  contentBg: "#f1f5f9",
  cardBg: "#ffffff"
};

function MarketingDashboardLayout() {
  const [activeMenu, setActiveMenu] = useState("dashboard-page");
  const [adminData, setAdminData] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const res = await axios.get(
          "https://agpipefitting.org.et/api/admin/profile",
          { headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } }
        );
        setAdminData(res.data);
      } catch {
        navigate("/admin-login");
      }
    };
    fetchAdmin();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/admin-login");
  };

  const handleProfileUpdate = (data) => setAdminData(data);

  const renderContent = () => {
    switch (activeMenu) {
      case "dashboard-page": return <DashboardPage />;
      case "categories": return <CategoriesPage />;
      case "product-description": return <Productdescription />;
      case "blogs": return <BlogsPage />;
      case "banners": return <BannersPage />;
      case "requests": return <RequestsPage />;
      case "stock": return <ProductStocks />;
      case "saleslist": return <SalesDashboard />;
      case "edit-profile": return <ProfileEditPage adminData={adminData} onProfileUpdate={handleProfileUpdate} />;
      default: return <DashboardPage />;
    }
  };

  const menuItem = (key, icon, label) => (
    <Nav.Link
      onClick={() => setActiveMenu(key)}
      style={{
        color: activeMenu === key ? "#fff" : theme.textPrimary,
        background: activeMenu === key ? theme.sidebarActive : "transparent",
        borderRadius: "8px",
        padding: "10px 12px",
        marginBottom: "6px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontWeight: 500,
        transition: "0.2s"
      }}
    >
      {icon} {!collapsed && label}
    </Nav.Link>
  );

  return (
    <div style={{ display: "flex", background: theme.contentBg }}>

      {/* SIDEBAR */}
      <div
        style={{
          width: collapsed ? "80px" : "260px",
          height: "100vh",
          position: "fixed",
          background: theme.sidebarBg,
          padding: "20px 15px",
          transition: "0.3s"
        }}
      >
        <div style={{ color: "#fff", fontWeight: "bold", marginBottom: "20px", textAlign: "center" }}>
          {collapsed ? "AG" : "AG Marketing Team"}
        </div>

        <Nav className="flex-column">
          {menuItem("dashboard-page", <FaTachometerAlt />, "Dashboard")}

          <div style={{ color: theme.textMuted, fontSize: "12px", margin: "15px 8px 6px" }}>
            {!collapsed && "PRODUCTS"}
          </div>
          {menuItem("categories", <FaTags />, "Categories")}
          {menuItem("product-description", <FaBox />, "Products")}
          {menuItem("stock", <FaBox />, "Stock")}
          {menuItem("saleslist", <FaBox />, "Sales Report")}

          <div style={{ color: theme.textMuted, fontSize: "12px", margin: "15px 8px 6px" }}>
            {!collapsed && "MARKETING"}
          </div>
          {menuItem("blogs", <FaBlog />, "Blogs")}
          {menuItem("banners", <FaBullhorn />, "Banners")}

          <div style={{ color: theme.textMuted, fontSize: "12px", margin: "15px 8px 6px" }}>
            {!collapsed && "ORDERS"}
          </div>
          {menuItem("requests", <FaClipboardList />, "Requests")}
        </Nav>
      </div>

      {/* MAIN AREA */}
      <div style={{ marginLeft: collapsed ? "80px" : "260px", padding: "25px", width: "100%" }}>

        {/* NAVBAR */}
        <Navbar
          className="shadow-sm mb-4 px-4"
          style={{
            background: theme.cardBg,
            borderRadius: "12px",
            border: "1px solid #e2e8f0"
          }}
        >
          <FaBars
            style={{ cursor: "pointer", marginRight: "15px" }}
            onClick={() => setCollapsed(!collapsed)}
          />

          <Form className="d-flex ms-3" style={{ width: "300px" }}>
            <FormControl type="search" placeholder="Search..." />
          </Form>

          <Nav className="ms-auto align-items-center">
            <div style={{ marginRight: "20px", cursor: "pointer" }}>
              <FaBell size={18} />
              <Badge bg="danger" style={{ marginLeft: "-8px" }}>3</Badge>
            </div>

            <Navbar.Text className="me-3">
              <strong>{adminData?.name}</strong>
            </Navbar.Text>

            <NavDropdown title="Account" align="end">
              <NavDropdown.Item onClick={() => setActiveMenu("edit-profile")}>
                Edit Profile
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar>

        {/* CONTENT CARD */}
        <div
          style={{
            background: theme.cardBg,
            borderRadius: "14px",
            padding: "25px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
          }}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default MarketingDashboardLayout;
